import { Button } from 'blaze-components/WriterTopBar/Button'
import { ChevronLeft } from 'blaze-ui/icons/24'
import { AI } from 'blaze-ui/icons'
import {
  ArticlePostPreviewActionTypes,
  useArticlePostPreviewContext,
} from 'components/ArticlePostPreview/ArticlePostPreviewContext'
import { TopBar } from '../TopBar/TopBar'

export const AlternativeOptionsMobileTopBar = () => {
  const {
    state: { oldCopy },
    dispatch,
  } = useArticlePostPreviewContext()

  return (
    <TopBar
      leftContent={
        <Button
          icon={ChevronLeft}
          onPress={() => {
            dispatch({ type: ArticlePostPreviewActionTypes.SET_CONTENT, payload: oldCopy })
            dispatch({ type: ArticlePostPreviewActionTypes.SET_CHANGING_COPY, payload: false })
          }}
        />
      }
      icon={<AI />}
      title="Alternative Copy Options"
    />
  )
}
